import React from "react";
import { FaHandshake } from "react-icons/fa";
import MyPage from "../components/MyPage";

function Memberlogin() {
  return (
    <>
    <MyPage
      title="Memberlogin | Thrissur Jilla Pravasi Kootayma"
      description="Explore the history and journey of Thrissur Jilla Pravasi Kootayma since 2006, uniting Thrissur Pravasi families through service, culture, and welfare."
      keywords="Thrissur Pravasi history, Pravasi Kootayma history, Thrissur expatriates, Kerala Pravasi association"
    />
      {/* ===== INNER BANNER ===== */}
      <section className="inner-banner">
        <div className="inner-overlay"></div>

        <div className="inner-content animate-down">
          <h1>Member Login</h1>
        </div>

        <div className="breadcrumb animate-down">
          Home / <span>Member Login</span>
        </div>
      </section>

      {/* ===== LOGIN SECTION ===== */}
      <section className="login-section">
        <div className="login-wrapper">
          {/* LEFT IMAGE */}
          <div className="login-image animate-left">
            <img src="/assets/login.jpg" alt="Login" />
          </div>

          {/* RIGHT FORM */}
          <div className="login-form animate-right">
            <h2>
              <FaHandshake /> Login To Your Account <span></span>
            </h2>

            <form>
              <label>Enter Member ID / Username*</label>
              <input type="text" placeholder="Enter Member ID / Username" />

              <label>Enter Password*</label>
              <input type="password" placeholder="Enter Password" />

              <button type="submit">Login</button>

              <p className="links">
                Not a member? <a href="/">Create a new account</a>
              </p>

              <p className="links">
                Forgot Your Password? <a href="/">Click here</a>
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* ===== CSS ===== */}
      <style>{`
/* ================= PAGE LOAD ANIMATIONS ================= */
@keyframes slideLeft {
  from { opacity: 0; transform: translateX(-80px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideRight {
  from { opacity: 0; transform: translateX(80px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-60px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-left {
  animation: slideLeft 1s ease forwards;
}

.animate-right {
  animation: slideRight 1s ease forwards;
}

.animate-down {
  animation: slideDown 0.9s ease forwards;
}

/* ===== INNER BANNER ===== */
.inner-banner {
  position: relative;
  height: 420px;
  background: url("/assets/banner.jpg") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding-top: 120px;
}

.inner-overlay {

  inset: 0;
  background: rgba(0,0,0,0.65);
}

.inner-content {
  position: relative;
  z-index: 1;
}

.inner-content h1 {
  font-size: 48px;
  font-weight: 700;
  font-family: "Merriweather", serif;
}

.breadcrumb {
  position: absolute;
  bottom: -20px;
  left: 55px;
  border-radius: 4px;
  background: var(--primary-color);
  padding: 10px 25px;
  font-size: 20px;
  font-weight: 500;
  color: #000;
  z-index: 1;
}
/* ===== LOGIN SECTION ===== */
.login-section {
  padding: 100px 80px;
  background: #f7f9ee;
}

.login-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(0,0,0,0.15);
}

/* LEFT IMAGE */
.login-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* RIGHT FORM */
.login-form {
  padding: 60px 60px;
}

.login-form h2 {
  font-size: 32px;
  font-weight: 700;
  font-family: "Merriweather", serif;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;
}

.login-form h2 span {
  width: 60px;
  height: 2px;
  background: #000;
}

.login-form form {
  display: flex;
  flex-direction: column;
}

.login-form label {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 6px;
}

.login-form input {
  padding: 14px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}

.login-form input:focus {
  outline: none;
  border-color: #a8cf45;
}

/* BUTTON */
.login-form button {
  background: #a8cf45;
  border: none;
  padding: 14px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 6px;
  margin-top: 10px;
}

.login-form button:hover {
  background: #000;
  color: #fff;
}

/* LINKS */
.links {
  margin-top: 14px;
  font-size: 14px;
}

.links a {
  color: #ff2f6e;
  text-decoration: none;
  font-weight: 600;
}

.links a:hover {
  text-decoration: underline;
}

/* ===== RESPONSIVE (UNCHANGED) ===== */
@media (max-width: 768px) {
  .login-wrapper {
    grid-template-columns: 1fr;
  }
}
  @media (max-width: 768px) {
  .inner-content h1 {
    font-size: 36px;
  }

  .breadcrumb {
    left: 16px;
    bottom: -20px;
    padding: 8px 12px;
    font-size: 12px;
  }
}
  @media (max-width: 768px) {
  .login-section {
    padding: 60px 16px; /* ✅ mobile safe */
  }

  .login-form {
    padding: 40px 20px; /* ✅ right side cut stop */
  }
    login-image img {
    height: 220px;
  }
}

      `}</style>
    </>
  );
}

export default Memberlogin;
